import { Checkbox } from "primereact/checkbox";

const SelectableTreeNode = ({ node, selected, onRowClick, setSelectedNodeKeys }) => {
  const handleCheck = (e) => {
    const { checked } = e.target;
    const newSelection = checked ? [...selected, node?.key] : selected.filter((key) => key !== node?.key);
    setSelectedNodeKeys(newSelection);
  };

  return (
    <div onClick={(e) => onRowClick(e, node)} style={{ padding: "1rem" }}>
      <Checkbox checked={selected.includes(node?.key)} onChange={handleCheck} />
      <span style={{ marginLeft: "1rem" }}>
        {node.data.tipoItemPta.descTipoItemPta + ": " + node.codigoFiplanItem + " - " + node.data.descricaoItem}
      </span>
    </div>
  );
};

export default SelectableTreeNode;
